'use client';

import type { WebhookLogEntry } from './types';

const LOG_KEY = 'mediadispatch_webhook_logs';
const MAX_LOGS = 200;

function load(): WebhookLogEntry[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(LOG_KEY);
    return raw ? (JSON.parse(raw) as WebhookLogEntry[]) : [];
  } catch {
    return [];
  }
}

function save(logs: WebhookLogEntry[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LOG_KEY, JSON.stringify(logs));
}

export const webhookLogStore = {
  getLogs: (): WebhookLogEntry[] => load(),

  addLog: (entry: WebhookLogEntry): void => {
    const logs = load();
    // Prepend newest first, cap at MAX_LOGS
    const updated = [entry, ...logs].slice(0, MAX_LOGS);
    save(updated);
  },

  clearLogs: (): void => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(LOG_KEY);
  },
};
